import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'player-track-prev', 'PlayerTrackPrev', [["path",{"d":"M21 5v14l-8 -7z","key":"svg-0"}],["path",{"d":"M10 5v14l-8 -7z","key":"svg-1"}]]);